import styled from "styled-components";
import borders from "theme/borders.module.scss";
import spacing from "theme/spacing.module.scss";
import { Button, Flex, Form } from "antd";
import colors from "theme/colors.module.scss";
import shadows from "theme/shadows.module.scss";

export const Wrapper = styled.div`
    padding: ${spacing.spacingLG} ${spacing.spacing} ${spacing.spacingXL};
    display: flex;
    flex-direction: column;
    height: 100vh;
    justify-content: space-between;
`;

export const StyledButton = styled(Button)`
    border-radius: ${borders.borderRadiusSM};
    flex: 1;
    border: none;
`;

export const StyledFlex = styled(Flex)`
    height: 70vh;
`;

export const ButtonWrapper = styled(Flex)`
    width: 100%;
`;

export const CircleImage = styled.div`
  position: absolute;
  width: 100%;
  height: 380px;
  top: calc(50% - 380px / 2 + 122px);

  background: radial-gradient(
    50% 50% at 50% 50%,
    rgba(214, 185, 251, 0.6) 0%,
    rgba(214, 185, 251, 0.4) 100%
  );
  filter: blur(38px);
`;

export const StyledForm = styled(Form)`
    padding: ${spacing.spacingLG} ${spacing.spacing} ${spacing.spacingXL};
    border-top-left-radius: ${borders.borderRadiusXXL};
    border-top-right-radius: ${borders.borderRadiusXXL};
    position: absolute;
    bottom: 0;
    background-color: ${colors.primaryBackground};
    width: 100%;
    box-shadow: ${shadows.secondaryShadow};
`;

